'use strict';

import React                from 'react';
import PropTypes            from 'prop-types';
import Translations         from '../../utils/Translations';
import Flux                 from '../../flux/Flux';
import {VXPay}              from '../../utils/VXPay';
import VXButton             from "./VXButton/VXButton";
import {COLOR_TYPE_SUCCESS}                    from "./VXButton/ButtonHelper";
import {VXButtonLineConfig, VXButtonLineStyle} from "./VXButton/VXButtonConfig";
import STYLES                                  from "./VXButton/EnumVXButton";

class TextchatButton extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			guestIsLoggedIn:   Flux.Guest.isLoggedIn(),
			isActorOnline:     props.isActorOnline,
			messagePrice:      props.messagePrice,
		};

		this.onStartTextChatClick = this.onStartTextChatClick.bind(this);
		if (this.props.listenToNotificationEvents) {
			this.onNotificationChanged = this.onNotificationChanged.bind(this);
		}
	}

	componentDidMount() {
		if (this.props.listenToNotificationEvents) {
			Flux.Notification.addNotificationChangeListener(this.onNotificationChanged);
		}
	}

	componentWillUnmount() {
		if (this.props.listenToNotificationEvents) {
			Flux.Notification.removeNotificationChangeListener(this.onNotificationChanged);
		}
	}

	onStartTextChatClick(e) {
		if (this.state.guestIsLoggedIn) {
			Flux.Messenger.selectChannelByActorId(this.props.actorId, true);
		} else {
			VXPay.openSignupOrLogin();
		}

		if (typeof e === 'object' && e.cancelable) {
			e.preventDefault();
			e.stopPropagation();
		}
	}

	onNotificationChanged(notification) {
		const NotificationTypes = Flux.Constants.ApiTypes.Notification.Incoming;

		switch (notification.type) {
			case NotificationTypes.ACTOR_ONLINE:
				if (notification.actorId === this.props.actorId) {
					this.setState({
						isActorOnline: true,
					});
				}
				break;
			case NotificationTypes.ACTOR_OFFLINE:
				if (notification.actorId === this.props.actorId) {
					this.setState({
						isActorOnline: false,
					});
				}
				break;
			case NotificationTypes.MESSAGE_PRICE :
				if (notification.actorId === this.props.actorId) {
					this.setState({
						messagePrice: notification.messagePrice,
					});
				}
				break;
			default:
		}
	}

	render() {
		const classes = [];

		if (this.props.additionalClassNames.length > 0) {
			classes.push(this.props.additionalClassNames);
		}

		if (this.props.cssButtonModifier.length > 0) {
			classes.push(this.props.cssButtonModifier);
		}
		if (this.props.hideOnActorOnline && this.state.isActorOnline) {
			classes.push('h-disp-none');
		}

		const buttonText = typeof this.props.buttonText === 'string' && this.props.buttonText.length > 0 ? this.props.buttonText : Translations.get('EyeCatcherChatButtonStartMessenger1');

		return (
			<div className={classes.join(' ')} data-actor-id={(this.props.actorId) ? this.props.actorId : 0}>
				<VXButton
					line1={[new VXButtonLineConfig(buttonText, new VXButtonLineStyle([STYLES.UPPERCASE]))]}
					line2={[new VXButtonLineConfig(this.props.isGuestLoggedIn ? this.state.messagePrice : Translations.get('ChatButtonStartMessageSubline'))]}
					color={COLOR_TYPE_SUCCESS}
					icon={"-icon-chat-flat-line"}
					size={STYLES.SIZE.SMALL}
					onClick={this.onStartTextChatClick}
					animateSuccess={true}
					overrideStyles={{height: "55px"}}
				/>
			</div>
		);
	}
}

TextchatButton.defaultProps = {
	isActorOnline:                 false,
	isGuestLoggedIn:               false,
	additionalClassNames:          '',
	buttonText:                    '',
	tooltipText:                   '',
	hideOnActorOnline:             false,
	listenToNotificationEvents:    true,
	messagePrice:                  0,
	cssButtonModifier:             '',
};

TextchatButton.propTypes = {
	actorId:                       PropTypes.number.isRequired,
	messagePrice:                  PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
	isActorOnline:                 PropTypes.bool,
	isGuestLoggedIn:               PropTypes.bool,
	additionalClassNames:          PropTypes.string,
	buttonText:                    PropTypes.string,
	tooltipText:                   PropTypes.string,
	hideOnActorOnline:             PropTypes.bool,
	listenToNotificationEvents:    PropTypes.bool,
	cssButtonModifier:             PropTypes.string,
};

export default TextchatButton;
